import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CodeIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.59999 15.0004L6.59999 12.0004L9.59999 9.00039M14.4 9.00039L17.4 12.0004L14.4 15.0004M4.79999 21.6004C3.47451 21.6004 2.39999 20.5259 2.39999 19.2004V4.80039C2.39999 3.47491 3.47451 2.40039 4.79999 2.40039H19.2C20.5255 2.40039 21.6 3.47491 21.6 4.80039V19.2004C21.6 20.5259 20.5255 21.6004 19.2 21.6004H4.79999Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

CodeIcon.displayName = 'CodeIcon';
